// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// Compact mode controller - ajouté en premier pour s'assurer qu'il soit chargé
import CompactModeController from "./compact_mode_controller"
application.register("compact-mode", CompactModeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import ProgramNavigationController from "./program_navigation_controller"
application.register("program-navigation", ProgramNavigationController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import SettingsController from "./settings_controller"
application.register("settings", SettingsController)

import ChannelPreferencesController from "./channel_preferences_controller"
application.register("channel-preferences", ChannelPreferencesController)

import PreferencesSyncController from "./preferences_sync_controller"
application.register("preferences-sync", PreferencesSyncController)

import ProgramFilterController from "./program_filter_controller"
application.register("program-filter", ProgramFilterController)

import ProgramSortController from "./program_sort_controller"
application.register("program-sort", ProgramSortController)

import ChannelSortController from "./channel_sort_controller"
application.register("channel-sort", ChannelSortController)

import ProgramOrderController from "./program_order_controller"
application.register("program-order", ProgramOrderController)

import ChannelIconController from "./channel_icon_controller"
application.register("channel-icon", ChannelIconController)


